<template>
  <b-form-group
    label="Para Birimi"
    label-for="id_currencies"
  >
    <v-select
      id="id_currencies"
      v-model="dataItem.id_currencies"
      label="title"
      placeholder="Seçiniz"
      :reduce="item => item.id"
      :options="currencies"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'Currencies',
  components: {
    BFormGroup,
    vSelect,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['customerPrices/dataItem']
    },
    currencies() {
      return this.$store.getters['currencies/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('currencies/getDataList')
    },
  },
}
</script>
